import { webPaths } from "@zplanem/web-paths"

/**
 * Project sub-navigation config (ZPL-126), mirroring property-tabs.ts.
 * Future sections add a row here + a label in `t.projects.tabs`; the
 * sub-tab bar renders from this array. The index tab (details) has an
 * empty path so it maps to the bare project URL.
 */
export const PROJECT_TABS = [
	{ key: "details", path: "" },
	{ key: "tasks", path: "tasks" },
	{ key: "visualizations", path: "visualizations" },
	{ key: "inspirations", path: "inspirations" },
	{ key: "documents", path: "documents" },
	{ key: "budget", path: "budget" },
	{ key: "members", path: "members" },
] as const

type ProjectTab = (typeof PROJECT_TABS)[number]

export function projectTabPath(
	propertyId: string,
	projectId: string,
	tab: ProjectTab,
): string {
	if (tab.path === "tasks") return webPaths.projectTasks(propertyId, projectId)
	const base = webPaths.project(propertyId, projectId)
	return tab.path ? `${base}/${tab.path}` : base
}

/**
 * Members lives in the mobile More menu, not the bottom-bar tabs, so it
 * gets a dedicated path helper next to projectTabPath (ZPL-269 rev b).
 */
export function projectMembersPath(
	propertyId: string,
	projectId: string,
): string {
	return `${webPaths.project(propertyId, projectId)}/members`
}
